import { render, staticRenderFns } from "./MailchimpTemplate.vue?vue&type=template&id=dabebe66&scoped=true&"
import script from "./MailchimpTemplate.vue?vue&type=script&lang=js&"
export * from "./MailchimpTemplate.vue?vue&type=script&lang=js&"
import style0 from "./MailchimpTemplate.vue?vue&type=style&index=0&id=dabebe66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabebe66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
